class NavColour extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()
  }

  setupListeners () {
    this.handleMouseEnter = this.handleMouseEnter.bind(this)
    this.handleMouseLeave = this.handleMouseLeave.bind(this)

    this.els.swatch.elements.forEach((swatch) => {
      this.listeners.add(swatch, 'mouseenter', this.handleMouseEnter)
      this.listeners.add(swatch, 'mouseleave', this.handleMouseLeave)
    })
  }

  handleMouseEnter (e) {
    this.els.name.element.textContent = e.currentTarget.dataset.name
  }

  handleMouseLeave () {
    this.els.name.element.textContent = ''
  }
}

if (!customElements.get('nav-colour')) {
  customElements.define('nav-colour', NavColour)
}
